// IMPORTANT: Replace these placeholder price IDs with your actual Stripe price IDs
// 
// To create products in Stripe dashboard:
// 1. Go to: Products → + Add product
// 2. Create "BAcTrakr Premium Monthly": $1.99/month with 3-day trial
// 3. Create "BAcTrakr Premium Yearly": $19.99/year with 3-day trial
// 4. Copy the price IDs (price_xxxxx) and replace the placeholders below
//
// Also enable the Customer Portal: https://dashboard.stripe.com/settings/billing/portal

export const SUBSCRIPTION_PLANS = {
  monthly: {
    priceId: "price_1SQeaoP12Y8ZE5IN4HHUfUaS",
    name: "Monthly",
    price: "$1.99",
    interval: "month",
    description: "Billed monthly",
  },
  yearly: {
    priceId: "price_1SQeaoP12Y8ZE5IN5S1K6a8v",
    name: "Yearly",
    price: "$19.99",
    interval: "year",
    description: "Billed annually - Save 17%",
  },
} as const;

export type PlanType = keyof typeof SUBSCRIPTION_PLANS;
